import * as GC from '@grapecity/spread-sheets';
export class EmpyreanComment extends GC.Spread.Sheets.Comments.Comment  {
  row:number;
  col:number;
}
